import React from 'react'
import { Field } from 'formik'
import PropTypes from 'prop-types'
import { textFieldValidations } from '../../../constants/validations'
import TextField from './TextField'

const TextFieldFormik = (props) => {
  const { validate } = props

  return (
    <Field
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...props}
      validate={(value) => textFieldValidations(value, validate)}
      component={TextField}
    />
  )
}

TextFieldFormik.defaultProps = {
  type: 'text',
  validate: null
}

TextFieldFormik.propTypes = {
  type: PropTypes.string,
  validate: PropTypes.string
}

export default TextFieldFormik
